<template>
    <div>
        <ul>
            <li><a href="/">Home</a></li>
            <li>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Arrow-Right-Small">
                    <path id="Vector" d="M8.75373 8.47282C8.75373 8.47282 8.8207 8.5087 8.82383 8.5087C8.16206 7.67881 7.48093 6.86089 6.84583 6.00917C6.69098 5.8017 6.61146 5.47255 6.64338 5.21725C6.66326 5.05293 6.97453 4.77735 7.11159 4.80126C7.54004 4.87562 8.03127 4.9687 8.34987 5.23181C9.86384 6.48235 11.3585 7.75889 12.7997 9.09107C13.7994 10.0145 13.7163 10.9791 12.6302 11.8157C11.3653 12.7907 10.0741 13.7329 8.77727 14.6663C7.86177 15.3251 7.00487 15.3693 6.67529 14.8238C6.26514 14.1447 6.58688 13.318 7.51336 12.721C8.2149 12.2686 10.8045 10.495 10.7835 10.4336C10.1223 9.79096 9.46102 9.14879 8.79977 8.5061L8.75426 8.47386L8.75373 8.47282Z" fill="#201747"/>
                    </g>
                </svg>
            </li>
            <li>{{  title  }}</li>
        </ul>
    </div>
</template>

<script>

export default {
    name: 'breadcrumbsApp',
    props: ['title'],
    data() {
        return {
            show: false,
            showButton: false
        };
    },
    computed: {
    }
}

</script>

<style scoped lang="stylus">
    ul {
        display: flex;
        align-items: center;
        padding: 0;
        margin: 1rem 0;
        list-style: none;

        a {
            color: #201747;
            text-align: center;
            font-family: Manrope;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            text-decoration: none;
            transition-duration: .4s;

            &:hover {
                color: #2AD2C9;
            }
        }

        li {
            padding: 0 .3rem;
            display: inline-flex;
            align-items: center;
            justify-content: center;

            &:last-child {
                color: #1D2433;
                text-align: center;
                font-family: Manrope;
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                opacity: 0.5;
            }
        }
    }
</style>